const commonStrings = {
  en: {
    login: 'Login',
    cancel: 'Cancel',
    welcome: 'WELCOME',
    ok: 'OK',
    yesContinue: 'Yes, I want to continue',
    noCancel: 'No, not at this time',
    save: 'Save',
    yes: 'Yes',
    no: 'No',
    next: 'Next',
    previous: 'Previous',
    globalError: 'We’re having some technical issues at the moment. While we work to fix it, give us a call at 1-800-284-2365, or try again later.',
    noBack: 'No, take me back',
    close: 'Close',
    info: 'Provide Info',
    verifyEmail: 'Verify Email',
    print: 'Print',
    submit: 'Submit',
    remove: 'Remove',
    edit: 'Edit',
    enterCode: 'Enter Code',
    areYouSure: 'Are you sure you want to cancel?',
    yourProgressWontBeSaved: 'Your progress will not be saved.',
    noContinue: 'No, I want to continue',
    yesCancel: 'Yes, I want to cancel',
    continue: 'Continue',
    or: 'Or',
    delete: 'Delete',
    tnc: 'I have read and agree',
    termsNConditions: 'Terms & Conditions',
    agreeButton: 'I Agree',
    noCanceltxt: 'No, I don’t want to cancel',
    makeSelection: 'Please make a selection',
    enterServiceAccount: 'Enter a Service Account Number',
    enterAddress: 'Enter Address',
    thankYou: 'Thank You'
  },
  es: {
    edit: 'Editar',
    print: 'Imprimir',
    next: 'Siguiente',
    cancel: 'Cancelar',
    save: 'Salvar',
    submit: 'Sumisión',
    previous: 'Anterior',
    areYouSure: 'Estas seguro que quieres cancelar?',
    yourProgressWontBeSaved: 'Su progreso no se guardara.',
    noContinue: 'No, quiero continuar',
    yesCancel: 'Si, quiero cancelar',
    tnc: 'He leído y acepto',
    globalError: 'Estamos teniendo algunos problemas técnicos en este momento. Mientras trabajamos para solucionarlo, llámenos al 1-800-284-2365, o intente nuevamente más tarde.',
  },
  ko: {
    edit: '수정하기',
    print: '확인서 인쇄하기',
    next: '다음으로 가기 ',
    cancel: '취소하기',
    submit: '확인하고 제출하기',
    save: '저장하기 ',
    previous: '이전으로 가기',
    areYouSure: '취소 하시겠습니까? ',
    yourProgressWontBeSaved: '진행 상황이 저장되지 않습니다. ',
    noContinue: '아니요, 계속하십시오. ',
    yesCancel: '예, 취소합니다.',
    tnc: '본인은 이를 읽고 이에 동의합니다',
    globalError: '현재 기술적인 문제가 발생했습니다. 문제를 해결하는 동안 1-800-284-2365로 전화 주시거나 나중에 다시 시도해 주세요.',
  },
  vi: {
    edit: 'Sửa',
    save: 'Tiết kiệm',
    print: 'In Xác Nhận',
    submit: 'Xác Nhận và Nộp',
    next: 'Kế Tiếp',
    cancel: 'Hủy',
    previous: 'Trang Trước',
    areYouSure: 'Quý Vị có chắt chắn là muốn bãi bỏ không? ',
    yourProgressWontBeSaved: 'Những gì quý vị đã làm sẽ không được giữ lại. ',
    noContinue: ' Không, tôi muốn tiếp tục ',
    yesCancel: 'Vân, Tôi muốn bãi bỏ',
    tnc: 'Tôi đã đọc và đồng ý',
    globalError: 'Chúng tôi đang gặp một số vấn đề kỹ thuật vào lúc này. Trong khi chúng tôi làm việc để khắc phục, hãy gọi cho chúng tôi theo số 1-800-284-2365, hoặc thử lại sau.',
  },
  zh: {
    edit: '編輯',
    save: ' 儲存 ',
    print: ' 列印確認頁',
    submit: '確認並提交',
    next: ' 下一步 ',
    cancel: '取消',
    previous: '上一步',
    areYouSure: '您確定要取消？ ',
    yourProgressWontBeSaved: '您的進度不會保存。',
    noContinue: ' 不，繼續',
    yesCancel: '是，取消',
    tnc: '我已閱讀並同意',
    globalError: '我们目前遇到了一些技术问题。在我们努力修复时，请致电 1-800-284-2365，或稍后再试。'
  }
};

const localizedVersion = function (combinedSet) {
  var defaultLanguageObjKeys = combinedSet.en; // Default set
  var drupalLang = app.appService.getPageLocale();
  var data = Object.keys(combinedSet);
  if (drupalLang === 'zh-hans') {
    if (data.includes('zh')) {
      drupalLang = 'zh';
    } else {
      drupalLang = 'en';
    }
  } else if (drupalLang === 'pt-pt') {
    if (data.includes('pt')) {
      drupalLang = 'pt';
    } else {
      drupalLang = 'en';
    }
  } else if (!data.includes(drupalLang)) {
    drupalLang = 'en';
  }
  var newCombinedSet = {};
  if (drupalLang === 'en') {
    Object.keys(defaultLanguageObjKeys)
      .forEach(function eachKey(key) {
        newCombinedSet[key] = defaultLanguageObjKeys[key];
      });
  } else {
    defaultLanguageObjKeys = combinedSet.en; // Default Keys
    var newLang = combinedSet[drupalLang];
    var checkNewlanguageValues = newLang;  // New Language Set Values
    Object.keys(defaultLanguageObjKeys)
      .forEach(function eachKey(key) {
        if (!checkNewlanguageValues[key]) {
          app.logger.getLogger().info(key + " = " + defaultLanguageObjKeys[key]);
          newCombinedSet[key] = defaultLanguageObjKeys[key];
        }
        else {
          app.logger.getLogger().info(key + " = " + checkNewlanguageValues[key]);
          newCombinedSet[key] = checkNewlanguageValues[key];
        }
      });
  }
  return newCombinedSet;
};

export const getStrings = (specificStrings, requiredCommonStrings, requriedLogin) => {
  var combinedSet = app.appUtil._us().clone(specificStrings);

  if (requriedLogin) {
    app.appUtil._us().each(commonStrings,
      function (languageSet, key) {
        var object = {};
        app.appUtil._us().each(languageSet, function (stringValue, stringKey) {
          if (requiredCommonStrings && requiredCommonStrings.indexOf(stringKey) > -1) {
            object[stringKey] = stringValue;
          }
        });
        if (combinedSet[key] !== undefined) {
          app.appUtil._us().extend(combinedSet[key], object);
        }
        else {
          combinedSet[key] = object;
        }
      });
    let resultantLocalizedContent = {};
    let temp = localizedVersion(combinedSet);
    resultantLocalizedContent = temp;
    return resultantLocalizedContent;
  } else {
    //var combinedSet = app.appUtil._us().clone(specificStrings);
    app.appUtil._us().each(commonStrings,
      function (languageSet, key) {
        var object = {};
        app.appUtil._us().each(languageSet, function (stringValue, stringKey) {
          if (requiredCommonStrings.indexOf(stringKey) > -1) {
            object[stringKey] = stringValue;
          }
        });
        if (combinedSet[key] !== undefined) {
          app.appUtil._us().extend(combinedSet[key], object);
        }
        else {
          combinedSet[key] = object;
        }
      });
    //app.logger.getLogger().info("Combined Set " + JSON.stringify(combinedSet));
    return combinedSet;
  }
};
